import React, { useContext, useEffect, useMemo } from "react";
import { Card, Grid, Typography, Divider, Button } from "@mui/material";
// import JoditEditor from "jodit-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import FooterPdfTemplate from "../Branding/FooterPdfTemplate";
import { BrandingContext } from "../../BrandingProvider";

const InvoicePreview = () => {
  const brandingData = useContext(BrandingContext);
  const history = useHistory();
  const location = useLocation();
  const { invoiceData } = location.state || {};
  console.log("invoiceData", invoiceData);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  const normalConfig = useMemo(
    () => ({
      buttons: "",
      minHeight: "0",
      toolbar: false,
      showPlaceholder: false,
      style: {
        padding: "0px",
        width: "100%",
        backgroundColor: "#fff",
        color: "#000",
        fontWeight: "bold",
      },
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: false,
      enableDragAndDropFileToEditor: true,
    }),
    []
  );

  const handleDownload = async () => {
    const input = document.getElementById("invoice-template");

    if (!input) {
      console.error("No element found with id 'invoice-template'");
      return;
    }

    // Temporarily set increased dimensions for the PDF
    const originalStyle = input.style.cssText;
    input.style.width = "1200px"; // New increased width
    input.style.minHeight = `${1200 * 1.414}px`; // Adjust height to maintain A4 ratio

    const pdfWidthIn = 8.27; // A4 width in inches
    const pdfHeightIn = 11.69; // A4 height in inches

    html2canvas(input, {
      scale: 2, // Higher resolution
      useCORS: true, // Handle cross-origin images
      allowTaint: true,
      scrollY: 0,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("p", "in", [pdfWidthIn, pdfHeightIn]);
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidthIn, pdfHeightIn);
        pdf.save("Invoice.pdf");
      })
      .finally(() => {
        // Restore original style
        input.style.cssText = originalStyle;
      });
  };
  const handleHomeButton = () => {
    history.push("/doctor/invoice");
  };
  // Function to decode base64 to JSON
  // function decodeBase64ToJson(base64String) {
  //     try {
  //       // Decode base64 and parse the JSON string
  //       const jsonString = atob(base64String);
  //       return JSON.parse(jsonString);
  //     } catch (error) {
  //       console.error("Failed to decode base64 or parse JSON", error);
  //       return null;
  //     }
  //   }

  //   // Find the 'collateral_image.png'
  //   const collateralImage =
  //     brandingData?.find((item) => item.name === "collateral_image.png")?.content || null;

  //   // Find the 'branding_statements.json' and decode its base64 content
  //   const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  //   const brandingContent = brandingItem ? decodeBase64ToJson(brandingItem.content) : null;

  //   // Extract the 'collateralBrandStatement' and 'themeColour' from decoded JSON
  //   const collateralBrandStatement = brandingContent?.collateralBrandStatement || null;
  //   const themeColour = brandingContent?.themeColour || "#21cdc0";

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#BAF0EB";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;

  // Find the 'email_banner.png' and get its base64 content directly
  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const emailBanner = emailBannerItem?.content || null;

  return (
    <>
      <Card
        style={{
          width: "85%",
          height: "100%",
          padding: "16px",
          marginLeft: "10%",
          marginTop: "5%",
        }}
      >
        <div id="invoice-template">
          {invoiceData ? (
            <Card style={{ height: "auto" }}>
              {/* Invoice Header with Colored Bar */}
              <Grid
                container
                style={{ backgroundColor: themeColour, padding: "20px", borderColor: "#179288", borderStyle: "solid", borderWidth: "1px" }}
              >
                <Grid item xs={6}>
                  {/* <Typography
                    variant="h4"
                    style={{ color: "black", fontWeight: "bold" }}
                  >
                    INVOICE
                  </Typography> */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.2rem", md: "1.8rem" },
                    }}
                  >
                    INVOICE
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {collateralImage && (
                    <img
                      src={`data:image/png;base64,${collateralImage}`}
                      alt="Collateral"
                      width="100px"
                      height="60px"
                      style={{ paddingBottom: "3px", paddingTop: "5px" }}
                    />
                  )}
                  {/* {collateralBrandStatement && (
                    <Typography variant="subtitle1" color="grey">
                      {collateralBrandStatement}
                    </Typography>
                  )} */}
                </Grid>
              </Grid>

              {/* Billed To and Invoice Details */}
              <Grid container style={{ padding: "20px", marginTop: "10px" }}>
                <Grid item xs={6}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Billed To
                  </Typography>
                  <Typography variant="subtitle1">
                    {invoiceData.patientName}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Invoice No: {invoiceData.invoiceNumber}
                  </Typography>
                  <Typography variant="subtitle1">
                    Date: {invoiceData.invoiceDate}
                  </Typography>
                  <Typography variant="subtitle1">
                    Expiry Date: {invoiceData.dueDate}
                  </Typography>
                  <Typography variant="subtitle1">
                    Notes: {invoiceData.notes}
                  </Typography>
                </Grid>
              </Grid>

              {/* Item Table */}
              <Grid item xs={12} style={{ padding: "20px" }}>
                <Grid
                  container
                  style={{
                    borderTop: "1px solid #ccc",
                    borderBottom: "1px solid #ccc",
                    padding: "10px",
                    fontWeight: "bold",
                  }}
                >
                  <Grid item xs={3}>
                    Item
                  </Grid>
                  <Grid item xs={3}>
                    Quantity
                  </Grid>
                  <Grid item xs={3}>
                    Price (₹)
                  </Grid>
                  <Grid item xs={3}>
                    Amount (₹)
                  </Grid>
                </Grid>

                {invoiceData.itemsList.map((item, index) => (
                  <Grid
                    container
                    key={index}
                    style={{
                      borderBottom: "1px solid #ccc",
                      padding: "10px 0",
                    }}
                  >
                    <Grid item xs={3}>
                      {item.itemName}
                    </Grid>
                    <Grid item xs={3}>
                      {item.quantity}
                    </Grid>
                    <Grid item xs={3}>
                      ₹{item.price}
                    </Grid>
                    <Grid item xs={3}>
                      ₹{item.amount}
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              {/* Total and Footer */}
              <Grid container style={{ padding: "20px" }}>
                <Grid item xs={12} style={{ textAlign: "right" }}>
                  <Typography variant="subtitle1">
                    Subtotal: ₹{invoiceData.subtotal}
                  </Typography>
                  <Typography variant="subtitle1">
                    Discount(%): {invoiceData.discount}
                  </Typography>
                  <Typography variant="subtitle1">
                    Tax(%): {invoiceData.tax}
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Total: ₹{invoiceData.total_amount}
                  </Typography>
                  <Typography variant="subtitle1">
                    Payment: ₹{invoiceData.partialPayment}
                  </Typography>
                  <Typography variant="subtitle1">
                    Balance Amount: ₹
                    {(
                      invoiceData.total_amount - invoiceData.partialPayment
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
              <FooterPdfTemplate />
            </Card>
          ) : (
            <h1>Loading Invoice</h1>
          )}
        </div>

        {/* <div
          style={{ textAlign: "center", marginTop: "20px", marginRight: "30%" }}
        >
          <button
            onClick={handleDownload}
            className="listening-button"
            style={{ marginLeft: "45%" }}
          >
            Download
          </button>
          <button onClick={handleHomeButton} className="listening-button">
            Go to Home
          </button>
        </div> */}

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          style={{ outline: 'none', border: 'none', marginTop: "20px" }}
        >
          <Grid item xs={12} sm={5} md={5} lg={4} style={{ textAlign: "center" }}>
            <button
              type="button"
              className="btn btn__secondary btn__rounded btn__block mt-2"
              onClick={handleDownload}
              // onMouseEnter={(e) => {
              //   e.target.style.background = "#99E8E2 !important";
              //   e.target.style.color = "#000000 !important";
              //   e.target.style.border = "2px solid #2196F3 !important";
              // }}
              // onMouseLeave={(e) => {
              //   e.target.style.background = "#D0EAD1 !important";
              //   e.target.style.color = "#017B40 !important";
              //   e.target.style.border = "2px solid #85C988 !important";
              // }}
              // sx={{
              //   all: 'unset', // Resets all inherited MUI and browser styles
              //   background: "#D0EAD1 !important",
              //   color: "#017B40 !important",
              //   border: "2px solid #85C988 !important",
              //   padding: "6px 5px 6px 5px !important",
              //   borderRadius: "10px !important",
              //   fontSize: "28px !important",
              //   fontStyle: "medium !important",
              //   cursor: "pointer !important",
              //   // display: "inline-block !important",
              //   width: "100% !important", // Ensures the button fills the grid item
              //   "&:hover": {
              //     background: "#99E8E2 !important",
              //     color: "#000000 !important",
              //     border: "2px solid #2196F3 !important",
              //   },
              // }}
              style={{
                color: "white",
                padding: "6px 5px 6px 5px !important",
                width: "100%",
                // transition: "background-color 0.3s ease",
                backgroundColor: "#0e3f66",
                borderRadius: "10px",
                // boxShadow: "0px 4px 4px 0px #00000040 inset"
                fontSize: "28px !important",
              }}
            >
              DOWNLOAD ESTIMATE
            </button>
          </Grid>
          <Grid item xs={12} sm={5} md={5} lg={4} style={{ marginLeft: "auto", textAlign: "center", marginRight: "2.5vh" }}>
            {/* <div style={{ maxWidth: '100%', flexGrow: 1 }}> */}
            <button
              type="button"
              className="btn btn__secondary btn__rounded btn__block mt-2"
              onClick={handleHomeButton}
              // onMouseEnter={(e) => {
              //   e.target.style.background = "#99E8E2 !important";
              //   e.target.style.color = "#000000 !important";
              //   e.target.style.border = "2px solid #2196F3 !important";
              // }}
              // onMouseLeave={(e) => {
              //   e.target.style.background = "#D0EAD1 !important";
              //   e.target.style.color = "#017B40 !important";
              //   e.target.style.border = "2px solid #85C988 !important";
              // }}
              // style={{
              //   all: 'unset', // Resets all inherited MUI and browser styles
              //   background: "#D0EAD1 !important",
              //   color: "#017B40 !important",
              //   border: "2px solid #85C988 !important",
              //   padding: "6px 5px 6px 5px !important",
              //   borderRadius: "10px !important",
              //   fontSize: "28px !important",
              //   fontStyle: "medium !important",
              //   cursor: "pointer !important",
              //   // display: "inline-block !important",
              //   width: "100% !important", // Ensures the button fills the grid item
              //   "&:hover": {
              //     background: "#99E8E2 !important",
              //     color: "#000000 !important",
              //     border: "2px solid #2196F3 !important",
              //   }
              // }}
              style={{
                color: "white",
                padding: "6px 5px 6px 5px !important",
                width: "100%",
                // transition: "background-color 0.3s ease",
                backgroundColor: "#0e3f66",
                borderRadius: "10px",
                // boxShadow: "0px 4px 4px 0px #00000040 inset"
                fontSize: "28px !important",
              }}
            >
              GO TO HOME
            </button>
            {/* </div> */}
          </Grid>
        </Grid>
      </Card >
    </>
  );
};

export default InvoicePreview;
